/**
 * Componente ContainerPage que serve como um wrapper para páginas da aplicação.
 *
 * Este componente fornece uma estrutura consistente para as páginas, incluindo
 * um contêiner estilizado e um cabeçalho com título traduzível.
 *
 * @module ContainerPage
 */

import { useTranslation } from 'react-i18next';
import { StyledContainer, HeaderContainer } from './ContainerPage.Styles';

/**
 * Componente funcional que renderiza um contêiner de página com título traduzível.
 *
 * @param {Object} props - Propriedades do componente
 * @param {string} props.title - Chave de tradução para o título da página
 * @param {React.ReactNode} props.children - Componentes filhos a serem renderizados dentro do contêiner
 * @returns {JSX.Element} Componente de contêiner de página estilizado
 */
const ContainerPage = (props) => {
  // Hook de tradução para internacionalização
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <HeaderContainer> {t(props.title)}</HeaderContainer>
      {props.children}
    </StyledContainer>
  );
};

export default ContainerPage;
